function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M337.92,89.845C161.28,33.525,0,164.085,0,333.045c0,23.04,2.56,66.56,10.24,92.16c0,5.12,5.12,10.24,10.24,10.24h468.48 c5.12,0,10.24-5.12,12.8-10.24c5.12-25.6,10.24-69.12,10.24-92.16C512,222.965,442.88,123.125,337.92,89.845z M256,128.245 c15.36,0,25.6,10.24,25.6,25.6c0,15.36-10.24,25.6-25.6,25.6s-25.6-10.24-25.6-25.6C230.4,138.485,240.64,128.245,256,128.245z  M76.8,358.645c-15.36,0-25.6-10.24-25.6-25.6c0-15.36,10.24-25.6,25.6-25.6s25.6,10.24,25.6,25.6 C102.4,348.405,92.16,358.645,76.8,358.645z M148.48,225.525c-10.24,10.24-25.6,10.24-35.84,0c-10.24-10.24-10.24-28.16-2.56-38.4 c10.24-10.24,25.6-10.24,35.84,0S156.16,215.285,148.48,225.525z M256,384.245c-28.16,0-53.76-25.6-46.08-51.2 c7.68-25.6,46.08-102.4,46.08-102.4s38.4,76.8,46.08,102.4C309.76,358.645,284.16,384.245,256,384.245z M401.92,225.525 c-10.24,10.24-25.6,10.24-35.84,0s-10.24-25.6,0-35.84s25.6-10.24,35.84,0C409.6,197.365,409.6,215.285,401.92,225.525z  M435.2,358.645c-15.36,0-25.6-10.24-25.6-25.6c0-15.36,10.24-25.6,25.6-25.6s25.6,10.24,25.6,25.6 C460.8,348.405,450.56,358.645,435.2,358.645z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.78cf96a4.svg";
export { ForwardRef as ReactComponent };